import { render, staticRenderFns } from "./planGoods.vue?vue&type=template&id=5d558a27&"
import script from "./planGoods.vue?vue&type=script&lang=js&"
export * from "./planGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports